export const SearchConf = {
  query: {
    keys: [
      {
        key: 'id',
        operator: '$containsi',
      },
      {
        key: 'name',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search by ID or name',
  initialState: {
    value: '',
  },
};
